// src/components/store/sections/faqs/FaqV4AccordioncleanEmeraldMint.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV4AccordioncleanEmeraldMint(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={4}
      archKey="accordion_clean"
      archLabel="Clean Emerald Accordion"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
